import { Navigate, useParams } from "react-router-dom";

export default function UniversityTestResultsIndexPage() {
  const { universityId } = useParams();
  return <Navigate to={`/education/universities/${universityId}/test-results/current`} replace />;
}
